Apt.fn.make('footer', {
	/**
	 * Initialize module
	 *
	 * @returns {Object}
	 */
	init: function() {
		var priv = this.$private;

		$.screen.map([
			{
				max: 2,
				callback: function() {
					priv.initMobile();
				}
			},
			{
				min: 3,
				callback: function() {
					priv.initTablet();
				}
			}
		]);

		Apt.newsletter.init();

		priv.initTop();
	}
}, {
	/**
	 * Initialize mobile footer
	 */
	initMobile: function() {
		$$('footer').addClass('-is-collapsible');

		$$('footerHeading')
			.unbind()
			.on('click', function() {
				$(this).parent()
					.toggleClass('-is-expanded');
			}, {
				cancel: true,
				namespace: 'footerMobile'
			});
	},

	/**
	 * Initialize tablet footer
	 */
	initTablet: function() {
		$$('footer').removeClass('-is-collapsible');
	},

	/**
	 * Bind scroll to top
	 */
	initTop: function() {
		var $top = $$('top'),
			visibleClass = '-is-visible',
			lockedClass = '-is-locked';

		$.scroll.map([
			{
				target: 'ref:topScroll',
				callback: function() {
					$top.addClass(visibleClass);
				}
			},
			{
				target: 'ref:header',
				callback: function() {
					$top.removeClass(visibleClass);
				}
			},
			{
				target: 'ref:footer',
				callback: function() {
					$top.addClass(lockedClass);
				}
			},
			{
				target: 'ref:footer',
				threshold: -1,
				callback: function() {
					$top.removeClass(lockedClass);
				}
			}
		], {
			namespace: 'top'
		});

		$top.on('click', function() {
			$($._body).tween({
				scrollTop: 0
			});
		});
	}
});